export const TOP_COUNTRY_CODES = ['PT', 'GB', 'US', 'ES', 'FR'];


// WEBPACK FOOTER //
// ./src/enums/topCountries.js